import { useEffect, useState } from "react";

import { TenantSettingService } from "../../he-thong/tham-so-he-thong/TenantSettingService";

export const QR_PAYMENT_INVOICE_ENABLED_VALUE = "C";

export const useQrPaymentInvoiceEnabled = () => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    TenantSettingService.getList({
      key: TenantSettingService.key.THANH_TOAN_QRCODE_HOA_DON,
    }).then(({ items }) => {
      if (items?.length > 0) {
        setEnabled(items[0].value === QR_PAYMENT_INVOICE_ENABLED_VALUE);
      }
    });
  }, []);

  return enabled;
};

export const useQrPaymentSettings = (enabled: boolean = true) => {
  const [isQrPaymentEnabled, setIsQrPaymentEnabled] = useState(false);
  const [isCreateQrForDraftEnabled, setIsCreateQrForDraftEnabled] = useState(false);

  useEffect(() => {
    if (!enabled) return;

    TenantSettingService.getList({
      key: TenantSettingService.key.THANH_TOAN_QRCODE_HOA_DON,
    })
      .then(({ items }) => {
        console.log("THANH_TOAN_QRCODE_HOA_DON items:", items);
        if (items?.length > 0) {
          setIsQrPaymentEnabled(items[0].value === QR_PAYMENT_INVOICE_ENABLED_VALUE);
        }
      })
      .catch((err) => {
        console.error("Error fetching THANH_TOAN_QRCODE_HOA_DON setting:", err);
      });

    TenantSettingService.getList({
      key: TenantSettingService.key.TAO_QRCODE_HD_CHO_KY,
    })
      .then(({ items }) => {
        console.log("TAO_QRCODE_HD_CHO_KY items:", items);
        if (items?.length > 0) {
          setIsCreateQrForDraftEnabled(items[0].value === QR_PAYMENT_INVOICE_ENABLED_VALUE);
        }
      })
      .catch((err) => {
        console.error("Error fetching TAO_QRCODE_HD_CHO_KY setting:", err);
      });
  }, [enabled]);

  return { isQrPaymentEnabled, isCreateQrForDraftEnabled };
};

